import React, { Component } from 'react'
import { Grid, ListItem } from '@material-ui/core'
import { EditableTextField } from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'

export default class NoteItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      editMode: false,
      parent: {},
      editIndex: -1,
      notes: props.notes || [],
    }
  }

  componentDidMount() {
    if (!this.props.note.message || !this.props.note.message.trim()) {
      this.setState({ editIndex: this.props.index })
    }
  }

  EnableEdit = (i) => {
    this.setState({ editMode: true, editIndex: this.props.index })
  }

  DisableEdit = (i) => {
    this.setState({ editMode: false, editIndex: -1 })
  }

  onSave = () => {
    if (!this.props.note.message || !this.props.note.message.trim()) {
      console.log('empty message')
    } else {
      this.props.onSave()
      this.setState({ editMode: false, editIndex: -1 })
    }
  }

  onChange = (e) => {
    console.log(this.state.notes, 'notes')
    let { notes = [] } = this.state
    notes[this.state.editIndex]['message'] = e.target.value
    this.setState({ notes })
    this.props.onChange(notes)
  }

  render() {
    return (
      <ListItem>
        <Grid container>
          <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
            <EditableTextField
              value={this.props.note.message || ''}
              valueToRender={this.props.note.message}
              placeholder={'Notes'}
              editMode={this.state.editIndex === this.props.index}
              type={'text'}
              onChange={this.onChange}
            />
          </Grid>
          {this.props.editMode ? (
            <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
              <EditActionComponent
                onSave={this.onSave}
                onCancel={this.DisableEdit}
                onEdit={this.EnableEdit}
                editMode={this.state.editIndex === this.props.index}
              />
            </Grid>
          ) : null}
        </Grid>
      </ListItem>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Notes/NoteItem.js